export enum StoryEndpoints {
  CreateStory = '/stories',
  FetchByEntityType = '/stories/by/entity/:entityType/:entityId',
  DeleteStory = '/stories/:id',
}
